import { http } from "@/core/api/";

const baseURL = "api/childcount";

export default {
  getChildCountSearchInitialFilterValues(properties) {
    return http.get("api/childcount/initfilters", {
      params: {
        ...properties
      }
    });
  },
  getChildCountSearchData(properties) {
    return http.get("api/childcount", {
      params: {
        ...properties
      }
    });
  },
  searchStudent(
    childCountCertificationId,
    studentSieIdOrRegistry,
    academicYearId,
    locationSchoolId
  ) {
    return http.get(
      `${baseURL}/${childCountCertificationId}/studentsearch/${studentSieIdOrRegistry}/${academicYearId}/${locationSchoolId}`
    );
  },
  addStudent(childCountCertificationId, studentSieId) {
    return http.post(`${baseURL}/addStudent`, {
      childCountCertificationId,
      studentSieId
    });
  },
  getSchoolCustodian(locationSchoolId) {
    return http.get(`${baseURL}/schoolcustodians`, {
      params: {
        locationSchoolId
      }
    });
  },
  assignCustodian(childCountCertificationStudentId, custodianUserId) {
    return http.put(`${baseURL}/assingcustodian`, {
      childCountCertificationStudentId,
      custodianUserId
    });
  },
  include(childCountStudentCertificationId, academicYearId, locationSchoolId) {
    return http.post(`${baseURL}/include`, {
      childCountStudentCertificationId,
      academicYearId,
      locationSchoolId
    });
  },
  removeManualStudent(childCountCertificationStudentId) {
    return http.delete(`${baseURL}/removestudent`, {
      params: {
        childCountCertificationStudentId
      }
    });
  },
  async submitCertification(childCountCertificationId) {
    return await http.put(`${baseURL}/submit`, {
      childCountCertificationId: childCountCertificationId
    });
  },
  async loadStudentCertification(
    certificationId,
    isPrivateSchool,
    searchMode,
    filters = {}
  ) {
    return await http.get(`${baseURL}/studentcertifications`, {
      params: {
        childCountCertificationId: certificationId,
        StudentFilter: filters.sie,
        CustodianUserId: filters.teacher,
        alertFilterId: filters.alertFilterId,
        searchMode,
        isPrivateSchool
      }
    });
  },
  async loadCertification(certificationId) {
    return await http.get(`${baseURL}/certifications`, {
      params: {
        childCountCertificationId: certificationId
      }
    });
  },
  async loadStudentExcludeReasons() {
    return await http.get(`api/code/childcountexcludereasons`);
  },
  async getSchoolCustodianAsync(locationSchoolId) {
    return await http.get(`${baseURL}/schoolcustodians`, {
      params: {
        locationSchoolId
      }
    });
  },
  markAllToChangeStatus(properties, flagSelection) {
    return http.post(
      `${baseURL}/markalltochangestatus/${flagSelection}`,
      properties
    );
  },
  markIndividualToChangeStatus(childCountCertificationId, flagSelection) {
    return http.post(
      `${baseURL}/changeflagselectionindividual/${childCountCertificationId}/${flagSelection}`
    );
  },
  existSelectionToChangeStatus(properties) {
    return http.post(`${baseURL}/existselectiontochangestatus`, properties);
  },
  approveMultiple(properties) {
    return http.post(`${baseURL}/approvemultiple/`, properties);
  },
  getProgressChildCount(acedemicYearId) {
    return http.get(`${baseURL}/getprogresschildcount/${acedemicYearId}`);
  },
  changePreviousStatus(childCountCertificationId) {
    return http.post(
      `${baseURL}/changepreviousstatus/${childCountCertificationId}`
    );
  },
  getHistory(childCountCertificationId) {
    return http.get(`${baseURL}/history/${childCountCertificationId}`);    
  }
};
